import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/api';
@Component({
  selector: 'app-primeng-custom-dialog',
  templateUrl: './primeng-custom-dialog.component.html',
})
export class PrimengCustomDialogComponent implements OnInit {

  selectedRow: any;
  constructor(public ref: DynamicDialogRef, public config: DynamicDialogConfig) { }

  ngOnInit(): void {
  }

  close(action) {
    this.ref.close(action);
  }

}
